export default "__VITE_PUBLIC_ASSET__9669c01c__"